const emptyFunction = function () {
}

function Evt (id) {
  this.id = id || Date.now()
  this.list = {}
}

Evt.prototype.on = function (type, fn, onlyOnce) {
  if (!this.list[type]) {
    this.list[type] = []
  }

  this.list[type].push({
    fn: fn,
    onlyOnce: !!onlyOnce
  })

  return this
}

Evt.prototype.one = function (type, fn) {
  this.on(type, fn, true)
  return this
}

Evt.prototype.off = function (type, fn) {
  for (let i in this.list) {
    if (this.list.hasOwnProperty(i)) {
      if (type === i) {
        if (!fn) {
          this.list[type].length = 0
        } else {
          const fnList = this.list[type]
          for (let i = fnList.length - 1; i >= 0; i--) {
            if (fn === fnList[i].fn) {
              fnList.splice(i, 1)
            }
          }
        }
        break
      }
    }
  }
  return this
}

Evt.prototype.offAll = function () {
  for (let i in this.list) {
    if (this.list.hasOwnProperty(i)) {
      this.list[i].length = 0
    }
  }
  return this
}

Evt.prototype.emit = function () {
  const type = Array.prototype.shift.call(arguments)
  const eventLists = this.list[type]

  if (!eventLists || !eventLists.length) {
    return emptyFunction
  }

  for (let i = 0; i < eventLists.length; i++) {
    const fnInfo = eventLists[i]
    const fn = fnInfo.fn
    const onlyOnce = fnInfo.onlyOnce

    fn.apply(this, arguments)
    if (onlyOnce) {
      eventLists.splice(i, 1)
    }
  }
}

export default Evt
